import {Component, EventEmitter, Input, OnInit} from '@angular/core';
import {FieldType} from '@ngx-formly/core';
import {FileManager} from '../../Models/FileManager';

@Component({
  selector: 'app-file-uploader-formly',
  templateUrl: './file-uploader-formly.component.html',
  styleUrls: ['./file-uploader-formly.component.scss']
})
export class FileUploaderFormlyComponent extends FieldType implements OnInit {
  label: string;
  description: string;
  accept: string;
  scope: 'backoffice' | 'dealer-system' = 'backoffice';
  bupload: string;
  fieldName: string;
  queueLimit = 1;
  ngModel: Array<any> = [];
  ngModelChange: EventEmitter<Array<FileManager> | FileManager> = new EventEmitter();

  constructor() {
    super();
  }

  ngOnInit() {
    if (this.field && this.field.templateOptions) {
      this.label = this.field.templateOptions.label;
      this.description = this.field.templateOptions.description;
      if (this.field.templateOptions.attributes) {
        this.accept = <string>this.field.templateOptions.attributes.accept;
        this.scope = <'backoffice' | 'dealer-system'>this.field.templateOptions.attributes.scope;
        this.bupload = <string>this.field.templateOptions.attributes.bupload;
        this.fieldName = <string>this.field.templateOptions.attributes.fieldName;
        this.queueLimit = this.field.templateOptions.attributes.queueLimit ? <number>this.field.templateOptions.attributes.queueLimit : 1;
      }
    }
    if (this.formControl) {
      this.ngModel = this.formControl.value ? this.formControl.value : [];
      this.ngModelChange.subscribe(v => {
        this.formControl.setValue(v);
      });
    }

  }

}
